import { render, staticRenderFns } from "./PromotionCodeEditor.vue?vue&type=template&id=4edc5700&"
import script from "./PromotionCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./PromotionCodeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports